import RequestManager from './RequestManager.js';

export const getDeploymentNotifications = async ({ deploymentId }) => {
    return RequestManager.get({
        url: `/notifications/v1/${deploymentId}`,
    });
};

export const sendNotification = async ({ deploymentId, userIds = [], templateId, body }) => {
    return RequestManager.post({
        url: `/notifications/push/users/v1/${deploymentId}?userIds=${userIds.join(',')}&templateId=${templateId}`,
        body,
    });
};

export const revokeRegistration = async ({ firebaseRegistrationId }) => {
    return RequestManager.del({
        url: `/registrations/revokeById/v1/${firebaseRegistrationId}`
    });
}